import React from 'react';
import styled from 'styled-components';

import IconButton from '@webtv/components/icon-button';
import CloseIcon from '@webtv/components/icons/close-icon';

import testIds from '@webtv/e2e/shared/variables';

import { DialogContext } from '../dialog';

export const DialogContentRoot = styled.div`
  position: relative;
  width: 100%;
  overflow-y: auto;
  border-radius: ${(props) => `${props.theme.shape.borderRadius.sm}px`};
`;

export const DialogContentClose = styled.span`
  position: absolute;
  top: 16px;
  right: 16px;
`;

interface Props extends React.HTMLAttributes<HTMLDivElement> {}

export const DialogContent: React.FC<Props> = (props: Props) => {
  const { children, ...rest } = props;

  const { onClose, hideCloseIcon } = React.useContext(DialogContext);

  return (
    <DialogContentRoot {...rest}>
      {!hideCloseIcon && (
        <DialogContentClose>
          <IconButton onClick={onClose} data-testid={testIds.dialog.close}>
            <CloseIcon />
          </IconButton>
        </DialogContentClose>
      )}

      {children}
    </DialogContentRoot>
  );
};

export default DialogContent;
